import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changePage,
  setCurrentMovie
} from '../../../action/VodAction';
import MovieInfo from '../movie-info/moiveInfo'
import defaultImagePic from '../../../images/thumb_movie.jpg'
import { VODSearchColor } from '../../../JS/setColors'

class SearchMovies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matchedMovies: [],
      searchClick: false,
      movieList: this.props.movieList,
      searchTerm: null,
      noImage: [],
    }
  }
  componentDidMount() {
    this.setState({ movieList: this.props.movieList })
    VODSearchColor(this.props.menuColor)
  }

  goBack = () => {
    this.props.changePage(1);
  }
  showMovieInfo = (current) => {
    this.setState({ matchedMovies: [] });
    this.props.setCurrentMovie(current);
  }

  onSearchChange = (event) => {
    let searchTerm = event.target.value.toLowerCase().trim();
    let similerTerms = [], currentTitle;
    if (searchTerm.length >= 3) {
      this.props.movieList.map((iterator) => {
        currentTitle = iterator.videoTitle.toLowerCase().trim();
        if (currentTitle.includes(searchTerm)) {
          similerTerms.push(iterator);
        }
        return 0;
      })
    }
    if (this.state.searchClick) {
      this.setState({ matchedMovies: similerTerms, searchTerm: searchTerm, searchClick: false });
    } else {
      this.setState({ matchedMovies: similerTerms, searchTerm: searchTerm });
    }
  }

  searchClick = () => {
    console.log("searchClick")
    if (this.state.searchTerm) {
      this.setState({ searchClick: true, movieList: this.state.matchedMovies });
    }
  }

  searchKeyPress = (event) => {
    console.log("searchKeyPress");
    if (event.key === "Enter") {
      if (this.state.searchTerm) {
        this.setState({ searchClick: true, movieList: this.state.matchedMovies, matchedMovies: [] });
      }
    }
  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }
  render() {
    let count = 0;
    console.log("1111", this.state.movieList);
    return (
      <div>
        {!this.props.currentMovie ?
          <div id="movie-search-keyword" className="movie-widgets">
            <div
              className="search-back"
              data-target="movie-widgets"
              onClick={this.goBack}
              style={{ color: "#ffffff" }}>
              <i className="fa fa-chevron-left" style={{ color: "inherit" }}></i>
              Back
         </div>
            <h4>Search movies by Keyword</h4>
            <div className="listen-search">
              <div className="listen-search-box">
                <i
                  style={{ color: "inherit" }}
                  className="fa fa-search"
                  onKeyPress={this.searchKeyPress}
                  onClick={this.searchClick}
                >

                </i>
                <input
                  type="text"
                  name="listenSearch"
                  onChange={this.onSearchChange}
                  onKeyPress={this.searchKeyPress} />
              </div>
              <div id="movie-search">
                {this.state.matchedMovies.length > 0 ?
                  this.state.matchedMovies.map((iterator) => {
                    return (
                      <div
                        style={{ fontWeight: "bold", marginLeft: "10px" }}
                        onClick={() => { this.showMovieInfo(iterator) }}
                      >
                        {iterator.videoTitle}
                      </div>
                    )
                  }) :
                  null
                }
              </div>
            </div>
            <div id="movie-list-container" className="movie-container">
              <div className="movie-list">
                <div className="title all-caps">
                  Search Results for:
                {
                    this.state.searchClick ? `  ${this.state.searchTerm}` : null
                  }
                </div>
                <ul className="movie-widgets-list">
                  {this.state.movieList && this.state.movieList.length > 0 ?
                    this.state.movieList.map((iterator, index) => {
                      count++;
                      if (index < 6) {
                        return (
                          <li
                            onClick={() => { this.showMovieInfo(iterator) }}
                            id="resume-play"
                            className="default"
                            data-target=""
                            style={this.state.noImage.indexOf(iterator.videoId) === -1 ? {
                              background: ` url('${this.state.noImage.indexOf(iterator.videoId) === -1 ? iterator.promoImageUrl : defaultImagePic}') center center no-repeat`,
                              backgroundSize: "cover"
                            } : null}>
                            <img style={{ display: "none" }} alt="not found"
                              src={iterator.promoImageUrl} onError={() => { this.imageNotfound(iterator.videoId) }} />
                            <span className="movie-thumb-text">{iterator.videoTitle}</span>
                          </li>
                        )
                      }
                    }) : null

                  }
                  {
                    count === 0 ? <div className="title all-caps">No Match found</div> : null
                  }
                </ul>
              </div>
            </div>
          </div> :
          <MovieInfo />
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    movieList: state.store.vod.VODData ?
      state.store.vod.VODData.channelList : null,
    currentMovie: state.store.vod.currentMovie,
    menuColor: state.store.home.MenuColor
  }
}

export default connect(
  mapStateToProps, {
  changePage,
  setCurrentMovie
}
)(SearchMovies);